import type * as api from '@gitbook/api-client';
import { validateAnyContentReference } from '@gitbook/app-content-refs';
import { Schema } from '@gitbook/slate';

import { INLINE_BUTTON, LEAF_RICH_BLOCKS } from '../types';
import { DOCUMENT_ACTION_PARAMETERS, isDocumentButtonAction, isDocumentSearchScope } from './utils';

export const schema = Schema.create({
    inlines: {
        [INLINE_BUTTON]: {
            isVoid: true,
            parent: {
                types: LEAF_RICH_BLOCKS,
            },
            data: {
                label: (label) => typeof label === 'string',
                kind: (kind) =>
                    typeof kind === 'string' && (kind === 'primary' || kind === 'secondary'),
                size: (size) =>
                    size === undefined ||
                    (typeof size === 'string' &&
                        (size === 'small' || size === 'medium' || size === 'large')),
                icon: (icon) => icon === undefined || typeof icon === 'string',
                ref: (ref) => ref === undefined || validateAnyContentReference(ref),
                action: (action) => action === undefined || validateDocumentAction(action),
            },
        },
    },
});

function validateDocumentAction(action: unknown): action is api.DocumentAction {
    if (!action || typeof action !== 'object') {
        return false;
    }

    const { action: kind, scope, ...parameters } = action as Record<string, unknown>;
    if (!isDocumentButtonAction(kind)) {
        return false;
    }
    if (scope !== undefined && !(kind === 'search' && isDocumentSearchScope(scope))) {
        return false;
    }

    const expectedParameters = DOCUMENT_ACTION_PARAMETERS[kind];
    return (
        Object.keys(parameters).length === expectedParameters.length &&
        expectedParameters.every((parameter) => typeof parameters[parameter] === 'string')
    );
}
